import React, { useContext, useEffect } from 'react'
import { t } from '../../i18n/i18n'
import { Button } from '@fluentui/react-components'
import { Grid } from '../common/grid/Grid'
import { GridItem } from '../common/grid/GridItem'
import { ModalActions } from '../common/modal/Modal'
import { useForm } from 'react-hook-form'
import { UserAccount } from '../../api/schemas/schema'
import { DataContext } from '../../context/DataContext'
import { api } from '../../helpers/apiHelper'
import { handleMessage } from '../../helpers/stateHelper'
import { ModalAccountInformationForm } from './ModalAccountInformationForm'
import { createUserUpdateEmailRequest } from '../../helpers/emailHelper'
import { DraggableModal } from '../common/modal/DraggableModal'
import { Form } from '../common/form/Form'

type ModalAccountInformationProps = {
   open: boolean
   close: () => void
}
export const ModalAccountInformation = ({ open, close }: ModalAccountInformationProps) => {
   const dataContext = useContext(DataContext)
   const { userAccount, organisation } = dataContext.state
   const userAccountForm = useForm<UserAccount>()
   const {
      handleSubmit,
      reset,
      formState: { isDirty, isSubmitting },
   } = userAccountForm
   const closeAndReset = () => {
      reset()
      close()
   }
   const onSubmit = async (data: UserAccount) => {
      try {
         const updatedAccount = (await api().updateUserAccount(data)).data
         const emailRequest = createUserUpdateEmailRequest(dataContext, data)
         if (emailRequest) {
            await api().sendUpdateNotificationToAdmin(emailRequest)
         }
         const userAccounts = (await api().getUserAccountsByOrganisationId(organisation.id)).data
         dataContext.setRootState((prev) => ({
            ...prev,
            userAccount: updatedAccount,
            userAccounts,
         }))
         handleMessage(dataContext.setRootState, 'success', t('ItemSuccessfullyUpdated', { Item: t('Account') }))
         closeAndReset()
      } catch (error) {
         handleMessage(dataContext.setRootState, 'error', t('CouldNotUpdateItem', { Item: t('Account') }))
      }
   }
   useEffect(() => {
      if (open) reset(userAccount)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [open])
   return (
      <DraggableModal open={open} onClose={closeAndReset} title={t('AccountInformation')}>
         <Form onSubmit={handleSubmit(onSubmit)}>
            <Grid gap="L">
               <ModalAccountInformationForm userAccountForm={userAccountForm} />
               <GridItem size={'12/12'}>
                  <ModalActions>
                     <Button appearance="secondary" onClick={closeAndReset} disabled={isSubmitting}>
                        {t('Cancel')}
                     </Button>
                     <Button appearance="primary" type="submit" disabled={!isDirty || isSubmitting}>
                        {t('Save')}
                     </Button>
                  </ModalActions>
               </GridItem>
            </Grid>
         </Form>
      </DraggableModal>
   )
}
